import { ICON_TYPES } from '../constants';

export const ArrowLeftNormalIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.546 28.044">
      <path d="M14.014,28.042,0,14.016,14.016,0l0,4.662L6.525,12.094H30.546v4H7.14l6.875,6.741v5.209Z" />
    </svg>
  );
};

ArrowLeftNormalIcon.iconType = ICON_TYPES.ARROW_LEFT_NORMAL;
